import React, { useEffect } from "react";
import AOS from "aos";
import "aos/dist/aos.css";
import "./BilanComportemental.scss";
import Tarifs from "../../sections/Tarifs/Tarifs";
import { comportementalData } from "../../data/comportementalData";
import TrustIndexWidget from "../../sections/TrustIndexWidget/TrustIndexWidget";
import Contact from "../../sections/Contact/Contact";
import { Helmet } from "react-helmet";

const steps = [
  {
    title: "Échange et analyse",
    description:
      "Discussion avec le propriétaire pour comprendre le contexte et analyser la situation.",
    image: "chien-noir.png",
  },
  {
    title: "Diagnostic personnalisé",
    description:
      "Élaboration d’un plan d’action adapté à votre mode de vie et aux besoins de votre animal.",
    image: "chat-content.png",
  },
  {
    title: "Conseils pratiques",
    description:
      "Mise en place de recommandations et d’actions concrètes dès la première consultation.",
    image: "shiba.png",
  },
];

const BilanComportemental = () => {
  useEffect(() => {
    AOS.init({
      duration: 1000,
      once: true,
    });

    const handleAnimationEnd = (e) => {
      if (e.target.hasAttribute("data-aos")) {
        e.target.removeAttribute("data-aos");
      }
    };

    const elements = document.querySelectorAll("[data-aos]");

    elements.forEach((element) => {
      element.addEventListener("transitionend", handleAnimationEnd);
    });

    return () => {
      elements.forEach((element) => {
        element.removeEventListener("transitionend", handleAnimationEnd);
      });
    };
  }, []);

  return (
    <div id="bilan">
      <Helmet>
        <title>Bilan comportemental chien et chat | Pokélu</title>
        <meta
          name="description"
          key="description"
          content="En tant que comportementaliste, mon rôle est de vous accompagner de manière complète et personnalisée afin de mieux comprendre votre animal et de modifier les comportements gênants qui peuvent nuire à votre quotidien. Mon approche repose sur l’observation, l’analyse et la mise en place de solutions adaptées, dans le respect du bien-être et des besoins naturels de votre compagnon."
        />
      </Helmet>

      <section className="bilan-container section-container">
        <h1 className="title">Bilan comportemental - chiens et chats</h1>
        <div className="flex-container">
          <div className="text-content" data-aos="fade-right">
            <p>
              En tant que comportementaliste, mon rôle est de vous{" "}
              <strong>accompagner de manière complète et personnalisée</strong>{" "}
              afin de mieux comprendre votre animal et de{" "}
              <strong>modifier les comportements gênants</strong> qui peuvent
              nuire à votre quotidien. Mon approche repose sur l’observation,
              l’analyse et la mise en place de solutions adaptées,{" "}
              <strong>dans le respect du bien-être</strong> et des besoins
              naturels de votre compagnon.
            </p>

            <p>
              Lors de nos rendez-vous, je prends en compte votre environnement,
              votre mode de vie ainsi que la personnalité de votre animal pour
              vous proposer des{" "}
              <strong>conseils pratiques et des stratégies efficaces</strong>.
              Chaque situation étant unique, j’adapte mon accompagnement pour
              vous offrir des{" "}
              <strong>solutions durables et bienveillantes</strong>.
            </p>

            <blockquote>
              <em>« Apprendre à mieux comprendre »</em>
            </blockquote>

            <p>
              Grâce à un <strong>suivi personnalisé</strong>, je vous donne
              toutes les clés pour{" "}
              <strong>instaurer une relation harmonieuse</strong> et renforcer
              votre complicité avec votre animal. Mon objectif est de vous aider
              à mieux décrypter son langage, à{" "}
              <strong>améliorer votre communication</strong> et à construire un
              équilibre basé sur la <strong>confiance et la coopération</strong>
              .
            </p>

            <p>
              Que ce soit pour des problèmes de comportement, de la gestion
              émotionnelle ou simplement pour optimiser votre relation avec
              votre compagnon, je suis à votre écoute pour vous guider vers une{" "}
              <strong>cohabitation sereine et épanouissante</strong>.
            </p>
          </div>
          <div className="image-container" data-aos="fade-left">
            <img
              src="/img/bilan-comportemental/femme-et-chat.png"
              alt="Illustration femme et chat"
            />
          </div>
        </div>
      </section>

      {/* Étapes du bilan */}
      <section className="bilan-service-container section-container">
        {steps.map((step, index) => (
          <div
            style={{
              backgroundImage: `url("/img/bilan-comportemental/${step.image}")`,
            }}
            data-aos="fade-up"
            data-aos-duration="700"
            className="card"
            id={step.title}
            key={index}
          >
            <div>
              <h3 className="card-title">{step.title}</h3>
            </div>
            <p className="card-description">{step.description}</p>
          </div>
        ))}
      </section>

      <Tarifs
        listTarifs={comportementalData}
        accroche="Comprendre, adapter, apaiser : le bilan comportemental, une clé pour une <strong>meilleure relation</strong> avec votre compagnon."
      />
      {/* <TrustIndexWidget />  */}
      <Contact />
    </div>
  );
};

export default BilanComportemental;
